import {
    CardSlider,
    CardSliderItem,
    CardSliderItemRow,
} from "@hatch-digital-nl/bravilor-storybook";
import { JSX } from "react";
import { useNavigate } from "react-router-dom";
import { DstAssociationCard } from "../interfaces/ProductDetailViewTypes";
import { RouteEnum } from "../../../common/enums/RouteEnum";
import { DstProductDetailLabels } from "../utils/productDetailLabels";

interface Props {
    products?: DstAssociationCard[];
    title: string;
    loading?: boolean;
    labels: DstProductDetailLabels;
}

const buildCardRows = (
    product: DstAssociationCard,
    artNumberText: string,
): CardSliderItemRow[] => {
    const rows: CardSliderItemRow[] = [
        { label: artNumberText, value: product.identifier },
    ];

    if (product.similarProductsSpecification) {
        rows.push({
            label: product.similarProductsSpecification.label,
            value: product.similarProductsSpecification.value,
        });
    }

    return rows;
};

export const RelatedProducts = (props: Props): JSX.Element | null => {
    const navigate = useNavigate();

    if (!props.loading && (!props.products || props.products.length === 0)) {
        return null;
    }

    return (
        <CardSlider
            title={props.title}
            totalCount={props.loading ? undefined : props.products?.length}
            totalLabel={props.loading ? undefined : props.labels.total}
            loading={props.loading}
            className="c-card-slider--product-detail"
        >
            {(props.products ?? []).map((product) => (
                <CardSliderItem
                    key={product.id}
                    title={product.label}
                    image={product.image}
                    rows={buildCardRows(product, props.labels.artNr)}
                    buttonText={props.labels.viewProduct}
                    onButtonClick={() =>
                        navigate(`${RouteEnum.PRODUCT_RANGE}/${product.id}`)
                    }
                />
            ))}
        </CardSlider>
    );
};
